import Page from 'components/ui/Page'
import React from 'react'

const ComingSoon = ({ match }) => {
    return <Page>...</Page>
}

ComingSoon.propTypes = {}

export default ComingSoon
